/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */

export type TuberculosisHistoryDtoImmunosuppressionStatus =
  (typeof TuberculosisHistoryDtoImmunosuppressionStatus)[keyof typeof TuberculosisHistoryDtoImmunosuppressionStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TuberculosisHistoryDtoImmunosuppressionStatus = {
  YES: 'YES',
  NO: 'NO',
  UNKNOWN: 'UNKNOWN',
} as const;
